export default __webpack_public_path__ + "static/media/page-not-found.13e37e57.jpg";